import { Card, CardDescription, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Error } from '@/components/ui/error';
import { Loading } from '@/components/ui/loading';
import { Empty, EmptyIcon, EmptyTitle, EmptyDescription } from '@/components/ui/empty';

// The shared frame of the ideas and bugs tabs: a header with its action, and
// the items as a grid of cards.
const ItemGrid = ({ title, description, action, isLoading, error, items, empty, renderItem }) => {
  const renderBody = () => {
    if (isLoading) {
      return <Loading />;
    }
    if (error) {
      return <Error message={error} />;
    }
    if (items.length === 0) {
      return (
        <Empty className="min-h-[280px] rounded-lg border border-dashed">
          <EmptyIcon>{empty.icon}</EmptyIcon>
          <EmptyTitle>{empty.title}</EmptyTitle>
          <EmptyDescription>{empty.description}</EmptyDescription>
        </Empty>
      );
    }
    return <div className="grid grid-cols-1 gap-4 md:grid-cols-2 2xl:grid-cols-3">{items.map(renderItem)}</div>;
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4 space-y-0">
        <div className="space-y-1.5">
          <CardTitle className="text-xl">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </div>
        {action}
      </CardHeader>
      <CardContent>{renderBody()}</CardContent>
    </Card>
  );
};

export default ItemGrid;
